var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Wifi large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M25.0002 40.625H25.021M47.5135 18.1266C41.5825 12.6916 33.6786 9.375 24.9999 9.375C16.3213 9.375 8.41731 12.6916 2.48633 18.1266M9.85836 25.5062C13.8961 21.9493 19.1961 19.7917 25.0001 19.7917C30.8041 19.7917 36.1041 21.9493 40.1419 25.5062M32.705 32.8648C30.5819 31.2006 27.9068 30.2083 24.9999 30.2083C22.0491 30.2083 19.3371 31.2308 17.1989 32.9408",
    stroke: "#956446",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.81e8bc10fbc54aad31dd897962b77740.svg";
export { ForwardRef as ReactComponent };